import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/activity.ts

var activity_exports = {};

__export(activity_exports, {
  addMyActivityItem: function addMyActivityItem() {
    return _addMyActivityItem;
  },
  deleteMyActivityItem: function deleteMyActivityItem() {
    return _deleteMyActivityItem;
  },
  getActivityItems: function getActivityItems() {
    return _getActivityItems;
  },
  getMyActivityItems: function getMyActivityItems() {
    return _getMyActivityItems;
  },
  getRoutines: function getRoutines() {
    return _getRoutines;
  }
});

var _getActivityItems = function _getActivityItems() {
  return fetcher_default.get("/v4/activity_items");
};

var _getRoutines = function _getRoutines() {
  return fetcher_default.get("/v4/routines");
};

var _getMyActivityItems = function _getMyActivityItems() {
  return fetcher_default.get("/v4/activity_items/my_items");
};

var _addMyActivityItem = function _addMyActivityItem(param) {
  return fetcher_default.post("/v4/activity_items/create_my_item", param);
};

var _deleteMyActivityItem = function _deleteMyActivityItem(param) {
  return fetcher_default["delete"]("/v4/activity_items/destroy_my_item", param);
};

export { _getActivityItems as getActivityItems, _getRoutines as getRoutines, _getMyActivityItems as getMyActivityItems, _addMyActivityItem as addMyActivityItem, _deleteMyActivityItem as deleteMyActivityItem, activity_exports };